/* eslint-disable perfectionist/sort-imports */
import 'src/global.css';

// i18n
import 'src/locales/i18n';

// Import as a module in your JS
import 'react-bootstrap-typeahead/css/Typeahead.css';
// ----------------------------------------------------------------------

import React, { useEffect } from "react";
import Router from 'src/routes/sections';

import ThemeProvider from 'src/theme';

import { LocalizationProvider } from 'src/locales';

import { useScrollToTop } from 'src/hooks/use-scroll-to-top';
import { useNumberInputsIgnoreScroll } from 'src/hooks/use-number-inputs-ignore-scroll';

import ProgressBar from 'src/components/progress-bar';
import { MotionLazy } from 'src/components/animate/motion-lazy';
import SnackbarProvider from 'src/components/snackbar/snackbar-provider';
import { SettingsDrawer, SettingsProvider } from 'src/components/settings';


import { AuthProvider } from 'src/auth/context';
import ErrorBoundary from 'src/components/error-boundary/error-boundary';
import { initCrisp } from "./utils/crisp";
import { NotificationProvider } from './NotificationContext';
import { JobProgressProvider } from './JobProgressContext';
import { GlobalJobProgress } from './components/global-job-progress';
import { MergeRunProvider } from './sections/merge/context/merge-run-context';
import { BulkCrossListRunProvider } from './sections/bulk-cross-list/context/bulk-cross-list-run-context';

// ----------------------------------------------------------------------

export default function App () {
  useScrollToTop();
  useNumberInputsIgnoreScroll();

  useEffect(() => {
    initCrisp();
  }, []);

  return (
    <AuthProvider>
      <LocalizationProvider>
        <SettingsProvider
          defaultSettings={{
            themeMode: 'light', // 'light' | 'dark'
            themeDirection: 'ltr', //  'rtl' | 'ltr'
            themeContrast: 'default', // 'default' | 'bold'
            themeLayout: 'vertical', // 'vertical' | 'horizontal' | 'mini'
            themeColorPresets: 'default', // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
            themeStretch: false,
          }}
        >
          <ThemeProvider>
            <MotionLazy>
              <SnackbarProvider>
                <NotificationProvider>
                  <JobProgressProvider>
                    <BulkCrossListRunProvider>
                      <MergeRunProvider>
                        <ErrorBoundary>
                          <SettingsDrawer />
                          <ProgressBar />
                          <GlobalJobProgress />
                          <Router />
                        </ErrorBoundary>
                      </MergeRunProvider>
                    </BulkCrossListRunProvider>
                  </JobProgressProvider>
                </NotificationProvider>
              </SnackbarProvider>
            </MotionLazy>
          </ThemeProvider>
        </SettingsProvider>
      </LocalizationProvider>
    </AuthProvider>
  );
}
